// extracted by mini-css-extract-plugin
export default {"cta":"UH-z","disabled":"VH-z"};